module.exports = __webpack_public_path__ + "static/media/empty-state-upload-image.665d8f0b.svg";